import React, { useState, useEffect } from 'react'
import { ChatbotConversationFlowView } from '../../views'
import { ChatbotService } from '../../../services'
import { useTranslation } from 'react-i18next'
import { ModalUtil, SimpleLoading } from '../../pures'
import { useParams } from 'react-router-dom'
import { ReactFlowProvider } from '@xyflow/react'
import { useGlobalState } from '../../../GlobalState'

const ChatbotEditConversationFlowAction = () => {
    const { conversationId } = useParams()
    const { t } = useTranslation()
    const modalUtil = new ModalUtil()

    const url = process.env.REACT_APP_ETICKET_API
    const chatbotService = new ChatbotService(url)

    const [isLoading, setLoading] = useState(true)
    const [error, setError] = useState()
    const [isSaving, setIsSaving] = useState(false)
    const [updatedDate, setupdatedDate] = useState(null)
    const [initialData, setInitialData] = useState()
    const { botConfig } = useGlobalState()

    const getConversation = async () => {
        try {
            setLoading(true)
            let data = await chatbotService.getConversation(conversationId, botConfig?.id)

            const initialNode = {
                id: 'start',
                position: { x: 0, y: 0 },
                type: 'startNode',
                data: {
                    id: data.id,
                    name: data.name,
                    description: data.description,
                    keyWords: data.keyWords,
                    suggestedText: data.suggestedText
                }
            }
            data.nodes.push(initialNode)

            if (data.initialStepNodeId) {
                const initialEdge = { id: 'startEdge', source: 'start', target: data.initialStepNodeId.toString() }
                data.edges.push(initialEdge)
            }

            data.nodes.forEach((node, i) => {
                if (node.data.variables) node.data.variables = node.data.variables.join(', ')
                if (node.data.keyWords) node.data.keyWords = node.data.keyWords.join(', ')

                if (node.data.isFinalMessage) {
                    data.nodes.push({
                        id: `end${i}`,
                        type: 'endNode',
                        position: {
                            x: node.position.x + 200,
                            y: node.position.y + 100
                        }
                    })
                    data.edges.push({
                        id: `e${node.id}-end${i}`,
                        source: `${node.id}`,
                        target: `end${i}`
                    })
                }
            })

            setInitialData(data)
            setLoading(false)
            handleConvertUpdatedDate(data.updatedDate)
        } catch (error) {
            modalUtil.showModal('error', error.message, t('modal.pure.title.error'))
        }
    }

    const saveConversation = async (data) => {
        const { nodes, edges } = data
        setError(null)
        setIsSaving(true)
        try {
            const startNode = nodes.find(node => node.type === 'startNode')
            const initialStepNodeId = edges.find(edge => edge.source == 'start')?.target
            const body = {
                botId: initialData.botId,
                conversationId,
                name: startNode.data.name,
                description: startNode.data.description,
                suggestedText: startNode.data.suggestedText,
                initialStepConversationId: conversationId,
                initialStepNodeId,
                nodes: nodes.filter(node => node.type !== 'startNode'),
                edges: edges.filter(edge => edge.source !== 'start'),
            }

            if (startNode.data.keyWords) body.keyWords = startNode.data.keyWords.split(',').map(k => k.trim())

            const response = await chatbotService.saveConversation(body)
            if (response.data.data.updatedDate) {
                handleConvertUpdatedDate(response.data.data.updatedDate)
            }
            setInitialData({ ...body, keyWords: startNode.data.keyWords, nodes })
        } catch (error) {
            console.log(error)
            setError(error.message)
        } finally {
            setIsSaving(false)
        }
    }

    const handleConvertUpdatedDate = (date) => {
        const newDate = new Date(date);
        const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
        };
        // example: "10/09/2025, 22:36:21"
        const formatedDate = newDate.toLocaleString('es-ES', options);
        setupdatedDate(formatedDate)
    }

    useEffect(() => {
        if (botConfig?.id) {
            getConversation()
        }
    }, [botConfig?.id])

    if (isLoading) return <div className='loading'>
        <SimpleLoading />
    </div>

    return (
        <ReactFlowProvider>
            <ChatbotConversationFlowView
                initialData={initialData}
                isSaving={isSaving}
                getConversation={getConversation}
                saveConversation={saveConversation}
                updatedDate={updatedDate}
                error={error}
            />
        </ReactFlowProvider>
    )
}

export default ChatbotEditConversationFlowAction